export default "__VITE_ASSET__0615a13f__"